<script>
export default {
  name: "new-trash-icon",
};
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M13.9995 3.98665C11.7795 3.76665 9.54618 3.65332 7.31951 3.65332C5.99951 3.65332 4.67951 3.71999 3.35951 3.85332L1.99951 3.98665"
      stroke="white"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5.66797 3.31301L5.81464 2.43967C5.9213 1.80634 6.0013 1.33301 7.12797 1.33301H8.87464C10.0013 1.33301 10.088 1.83301 10.188 2.44634L10.3346 3.31301"
      stroke="white"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12.5674 6.09375L12.1341 12.8071C12.0607 13.8537 12.0007 14.6671 10.1407 14.6671H5.86075C4.00075 14.6671 3.94075 13.8537 3.86742 12.8071L3.43408 6.09375"
      stroke="white"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M6.88672 11H9.10672"
      stroke="white"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M6.33203 8.33301H9.66536"
      stroke="white"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
